export default "__VITE_ASSET__37ponf1w__"